// ** React hooks
import { useEffect, useState } from 'react'

// ** Dropdowns Imports
import UserDropdown from './UserDropdown'

// ** Third Party Components
import { Sun, Moon, Wifi, WifiOff } from 'react-feather'
import { NavItem, NavLink, UncontrolledTooltip } from 'reactstrap'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { conditionallyUpdateScrollbar } from 'reactstrap/lib/utils'

const NavbarUser = props => {
  // ** Props
  const { skin, setSkin } = props
  // const [isInternet, setIsInternet] = useState(navigator.onLine)
  const [updateState, setUpdateState] = useState(true)

  // ** Function to toggle Theme (Light/Dark)
  const ThemeToggler = () => {
    if (skin === 'dark') {
      return <Sun className='ficon cursor-pointer' onClick={() => setSkin('light')} />
    } else {
      return <Moon className='ficon cursor-pointer' onClick={() => setSkin('dark')} />
    }
  }

  // const Currentnetwork = () => {
  //   if (isInternet) {
  //     return (
  //     <>
  //       <OverlayTrigger
  //         placement="bottom"
  //         delay={{ show: 250, hide: 400 }}
  //         overlay={<Tooltip id="button-tooltip">Online</Tooltip>}
  //       >
  //         <Wifi id="wifi" color='#28c76f' data-toggle="tooltip" data-placement="bottom" title="Tooltip on bottom" className='ficon cursor-pointer mr-50' />
  //       </OverlayTrigger>
  //      </>
  //     )
  //   } else {
  //     return (
  //       <>
  //         <WifiOff id="wifi-off" color='#ea5455' className='ficon cursor-pointer mr-50'/>
  //         <UncontrolledTooltip className="tooltip-react-strap" target="wifi-off">
  //           Offline
  //         </UncontrolledTooltip>
  //       </>
  //     ) 
  //   }
  // }

  // window.ononline = (event) => {
  //   setIsInternet(true)
  // }
  
  // window.onoffline = (event) => {
  //   setIsInternet(false)
  // }

  return (
    <ul className='nav navbar-nav align-items-center ml-auto'>
      {/* <Currentnetwork /> */}
      <ThemeToggler />
      <UserDropdown />
    </ul>
  )
}
export default NavbarUser
